import enLocale from 'date-fns/locale/en-US'

const distanceInWordsLocale = {
    lessThanXSeconds: {
        one: '1 min',
        other: '1 min',
    },

    xSeconds: {
        one: '1 min',
        other: '1 min',
    },

    halfAMinute: '1 min',

    lessThanXMinutes: {
        one: '1 min',
        other: '1 min',
    },

    xMinutes: {
        one: '1 min',
        other: '{{count}} mins',
    },

    aboutXHours: {
        one: '~1 hour',
        other: '~{{count}} hours',
    },

    xHours: {
        one: '1 hour',
        other: '{{count}} hours',
    },

    xDays: {
        one: '1 day',
        other: '{{count}} days',
    },

    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months',
    },

    xMonths: {
        one: '1 month',
        other: '{{count}} months',
    },

    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years',
    },

    xYears: {
        one: '1 year',
        other: '{{count}} years',
    },

    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years',
    },

    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years',
    },
}

const localize = (token, count) => {
    if (typeof distanceInWordsLocale[token] === 'string') {
        return distanceInWordsLocale[token]
    }
    if (count === 1) {
        return distanceInWordsLocale[token].one
    }

    return distanceInWordsLocale[token].other.replace('{{count}}', count)
}

export const locale = {
    format: enLocale.format,
    formatDistance: localize,
}
